import { cn } from "@/zapi-frontend/shared/lib/utils";
import { useProjectSidebarStore } from "@/zapi-frontend/stores/projectSidebarStore";
import { useChapterStore } from "@/zapi-frontend/stores/chapter";
import { ValidationPanel } from "@/zapi-frontend/widgets/ValidationPanel";
import { IntelligenceQuestions } from "@/zapi-frontend/widgets/IntelligenceQuestions";
import { Claims } from "@/zapi-frontend/widgets/Claims";
import { CommentsIsland } from "@/zapi-frontend/widgets/CommentsIsland";
import { RepositoryIsland } from "./Repository/RepositoryIsland";

type TAnalysisIslandProps = { projectId: string; isChapterContentReady: boolean };

export function AnalysisIsland(props: TAnalysisIslandProps) {
  const { projectId, isChapterContentReady } = props;

  const { activeChapter } = useChapterStore();
  const { openSidebar } = useProjectSidebarStore();

  return (
    <div
      className={cn(
        "relative z-10 flex h-full w-full flex-1 flex-col overflow-hidden pt-2 pb-3 tablet:pl-3",
        !openSidebar && "opacity-0 pointer-events-none"
      )}
    >
      <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-2xl bg-card shadow-xs ring-1 ring-foreground/5">
        {openSidebar === "analysis" && (
          <div
            className={cn(
              "w-full h-full max-h-[calc(100vh-135px)] flex",
              activeChapter?.projectTemplateChapter.isExecutiveSummary && "max-h-[calc(100vh-284px)]"
            )}
          >
            <ValidationPanel projectId={projectId} isChapterContentReady={isChapterContentReady} />
          </div>
        )}

        {openSidebar === "intelligence-questions" && (
          <div
            className={cn(
              "w-full h-full max-h-[calc(100vh-135px)] flex",
              activeChapter?.projectTemplateChapter.isExecutiveSummary && "max-h-[calc(100vh-284px)]"
            )}
          >
            <IntelligenceQuestions projectId={projectId} />
          </div>
        )}

        {openSidebar === "claims" && (
          <div
            className={cn(
              "w-full h-full max-h-[calc(100vh-135px)] flex",
              activeChapter?.projectTemplateChapter.isExecutiveSummary && "max-h-[calc(100vh-284px)]"
            )}
          >
            <Claims projectId={projectId} />
          </div>
        )}

        {openSidebar === "comments" && (
          <div
            className={cn(
              "w-full h-full max-h-[calc(100vh-135px)] flex",
              activeChapter?.projectTemplateChapter.isExecutiveSummary && "max-h-[calc(100vh-284px)]"
            )}
          >
            <CommentsIsland />
          </div>
        )}

        {openSidebar === "vault" && (
          <div
            className={cn(
              "w-full h-full max-h-[calc(100vh-135px)] flex",
              activeChapter?.projectTemplateChapter.isExecutiveSummary && "max-h-[calc(100vh-284px)]"
            )}
          >
            <RepositoryIsland open />
          </div>
        )}
      </div>
    </div>
  );
}

export function AnalysisToolContent({ projectId, isChapterContentReady }: TAnalysisIslandProps) {
  const { openSidebar } = useProjectSidebarStore();
  return (
    <div className="flex h-full w-full min-w-0">
      {openSidebar === "analysis" && (
        <ValidationPanel projectId={projectId} isChapterContentReady={isChapterContentReady} />
      )}
      {openSidebar === "intelligence-questions" && <IntelligenceQuestions projectId={projectId} />}
      {openSidebar === "claims" && <Claims projectId={projectId} />}
      {openSidebar === "comments" && <CommentsIsland />}
      {openSidebar === "vault" && <RepositoryIsland open />}
    </div>
  );
}
